import type { ProspectHomepageSlide } from '@ps/web-martech-cms-types';
import classNames from 'clsx';
import React from 'react';

import { CMSHeading } from '@swf/cms';

import styles from './ColumnLayout.scss';

interface Props {
  headings: ProspectHomepageSlide['heading'][];
}

const Headings: React.FC<Props> = ({ headings }) => {
  const headingsWithTitles = headings.filter((h) => h.title);
  if (headingsWithTitles.length === 0) {
    return null;
  }

  return (
    <div className={classNames(styles.row, styles.headings)}>
      {headings.map((heading, i) => {
        const El = heading.level || 'h1';
        return heading.title ? (
          <CMSHeading key={i} {...heading} className={styles.heading} />
        ) : (
          <El key={i} className={styles.heading} />
        );
      })}
    </div>
  );
};

export default Headings;
